import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    formGroup: {
      marginTop: theme.spacing(4),
    },
    formLabel: {
      background: '#f3f3f3',
      padding: theme.spacing(2),
    },
    accordionSummary: {
      background: theme.palette.background.default,
    },
  }));